// extracted by mini-css-extract-plugin
module.exports = {"navLogo":"side-nav_navLogo_1nHcy","navTitle":"side-nav_navTitle_3uTJG","navSubtitle":"side-nav_navSubtitle_27Bcm"};